import * as React from 'react';

import type {ListItem} from 'nutshell-core/types';

import {LeadTwoLine} from 'shells/lead/lead-two-line';
import {PeepTwoLine} from 'shells/peep/peep-two-line';

import {RenderedCell} from '../../../../entity-list/columns/cell/generic';

import styles from './entity-list-mini-column.module.css';

type Props = {
    columnData: ListItem[];
    columnField: {
        name: string;
        type: string;
        title: string;
    };
};

export class EntityListMiniColumn extends React.Component<Props> {
    render() {
        const rightAlign = this.props.columnField.name !== 'name';

        return (
            <div className={rightAlign ? styles['container--right'] : styles.container}>
                <div className={styles['column-container']}>{this.renderColumn()}</div>
            </div>
        );
    }

    renderColumn() {
        if (this.props.columnField.name === 'name') {
            return this.props.columnData.map<React.ReactElement<any>>((cellData, index) => {
                return (
                    <div
                        key={`${this.props.columnField.name}-${cellData.id ? cellData.id : index}`}
                        className={styles['cell-container']}
                    >
                        {cellData.links.entity.type === 'leads' ? (
                            <LeadTwoLine
                                avatarUrl={cellData.avatarUrl}
                                htmlUrl={cellData.htmlUrl}
                                leadName={cellData.primaryName}
                                /* Let's not display lead number here */
                                leadNumber={null}
                                priority={cellData.priority}
                                relatedCompany={cellData.primaryAccount}
                                relatedPerson={cellData.primaryContact}
                                leadStatus={
                                    // Defaulting to open, but this should always exist. We just
                                    // pass leadStatus to determine whether to show hot leads
                                    // names as orange, if they're still open.
                                    cellData.fields &&
                                    cellData.fields.status &&
                                    cellData.fields.status.value
                                        ? cellData.fields.status.value.value
                                        : 'Open'
                                }
                                formattedValue={
                                    cellData.fields && cellData.fields.value
                                        ? cellData.fields.value.formattedValue
                                        : undefined
                                }
                                overdueDuration={
                                    cellData.fields && cellData.fields.overdueDuration
                                        ? cellData.fields.overdueDuration.value
                                        : undefined
                                }
                            />
                        ) : (
                            <PeepTwoLine
                                name={cellData.primaryName}
                                avatarUrl={cellData.avatarUrl}
                                initials={cellData.initials}
                                htmlUrl={cellData.htmlUrl}
                                type={cellData.links.entity.type}
                                shouldClientRoute={true}
                                relatedEntityName={cellData.relatedName}
                            />
                        )}
                    </div>
                );
            });
        }

        return this.props.columnData.map<React.ReactElement<any>>((cellData, index) => {
            return (
                <div
                    key={`${this.props.columnField.name}-${index}`}
                    className={styles['cell-container']}
                >
                    <RenderedCell cellData={cellData} columnData={this.props.columnField} />
                </div>
            );
        });
    }
}
